import type { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { MiscLogo } from './MiscLogo'
import { WavePattern } from './WavePattern'
import { MISC_NAVY, MISC_SURFACE } from '../theme/onboardingTheme'

interface PortalShellProps {
  heroTitle: string
  heroSubtitle?: string
  showHeroLogo?: boolean
  children: ReactNode
  /** Narrower left panel like dashboard (~35%) */
  heroNarrow?: boolean
}

export function PortalShell({
  heroTitle,
  heroSubtitle,
  showHeroLogo = true,
  children,
  heroNarrow = false,
}: PortalShellProps) {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: MISC_SURFACE }}>
      <Box
        component="aside"
        sx={{
          position: 'sticky',
          top: 0,
          height: '100vh',
          alignSelf: 'flex-start',
          display: { xs: 'none', lg: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflow: 'hidden',
          backgroundColor: MISC_NAVY,
          color: '#ffffff',
          width: heroNarrow ? { lg: 'min(420px, 36vw)' } : { lg: '50%' },
        }}
      >
        <WavePattern />
        <Box
          sx={{
            position: 'relative',
            zIndex: 10,
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            px: { lg: 5, xl: 7 },
            py: 6,
          }}
        >
          <Typography
            component="h1"
            sx={{
              maxWidth: 576,
              fontSize: { lg: '1.5rem', xl: '1.875rem' },
              fontWeight: 600,
              lineHeight: 1.35,
              letterSpacing: '-0.025em',
            }}
          >
            {heroTitle}
          </Typography>
          {heroSubtitle ? (
            <Typography sx={{ mt: 2, maxWidth: 448, fontSize: 14, lineHeight: 1.7, color: 'rgba(255,255,255,0.8)' }}>
              {heroSubtitle}
            </Typography>
          ) : null}
        </Box>
        {showHeroLogo ? (
          <Box sx={{ position: 'relative', zIndex: 10, p: { lg: 4, xl: 5 } }}>
            <MiscLogo light />
          </Box>
        ) : null}
      </Box>

      <Box component="main" sx={{ position: 'relative', display: 'flex', minHeight: '100vh', flex: 1, minWidth: 0, flexDirection: 'column' }}>
        {children}
      </Box>
    </Box>
  )
}
